import ENDPOINT from '../graphql/GraphQLConstants';
import { EIR_PREQUAL_CONST } from './Constants';

import axios from 'axios';

const prequalByData = async (graphql, formData, eirflag) => {
  try {
    let params;
    let endpoint;
    const eirflagMap = eirflag;
    if (eirflagMap == 'phone') {
      endpoint = ENDPOINT.GET_PREQUAL_BY_PHONENUMBER;
      params = {
        phoneNumber: {
          areaCode: formData.areaCode,
          teleNumber: formData.number,
        },
        channel: 'EIR_CONSUMER',
      };
    } else if (eirflagMap == 'eircode') {
      endpoint = ENDPOINT.GET_PREQUAL_BY_EIRCODE;
      params = {
        prequalAddress: {
          eircode: formData.eircode,
          addressLine1: formData.addressLine1,
          addressLine2: formData.addressLine2,
          addressLine3: formData.addressLine3,
          county: formData.county,
          town: formData.town,
        },
        channel: 'EIR_CONSUMER',
      };
    }
    const res = await graphql.query({
      query: endpoint,
      variables: params,
    });
    if (res.data.prequalData === null) {
      throw new Error('No prequal data found');
    }
    return res.data;
  } catch (err) {
    throw new Error(err);
  }
};

const getAddressList = async (graphql, eircode) => {
  try {
    /* In graphqlconstansts query the eircode defined like eirCode 
        so I am laso using the same otherwise getting error  */
    let eirCode = eircode;
    const res = await graphql.query({
      query: ENDPOINT.GET_ADDRESSLIST,
      variables: { eirCode },
    });
    if (res.data.addressList === null) {
      throw new Error('No address found for given eircode');
    }
    return res.data;
  } catch (error) {
    throw new Error(error);
  }
};

const getAreaCodes = async (graphql) => {
  try {
    const res = await graphql.query({
      query: ENDPOINT.GET_AREACODES,
    });
    if (res.data.areaCodes === null) {
      throw new Error('No areacodes found');
    }
    return res.data;
  } catch (error) {
    throw new Error(error);
  }
};

const getRecommendedBundles = async () => {
  const prequalId = '/cfade9f1-b2e8-467e-bcf1-b6e069aea14f';
  const context = '/?context=broadband';
  await axios({
    method: 'get',
    url: EIR_PREQUAL_CONST.url.recommendedBundle + prequalId + context,
  })
    .then(() => {
      // console.log(res);
    })
    .catch(() => {
      //any status other than 200 to go to offers/acc-mgmt
    });
};

const getPrequalFromId = async (prequalId) => {
  try {
    const { data } = await axios({
      method: 'get',
      url: EIR_PREQUAL_CONST.url.getPrequal + prequalId,
    });
    return data;
  } catch (error) {
    throw new Error(error);
  }
};

export {
  prequalByData,
  getAddressList,
  getAreaCodes,
  getRecommendedBundles,
  getPrequalFromId,
};
